// extracted by mini-css-extract-plugin
export default {"marginZero":"checkout-counter_marginZero__BDvwU"};